import ChartToolbar from "./leak-chart-toolbar"
import LeakChart from "./leak-chart"
import { leakChartStore } from "./leak-chart-store"
import Wrapper from "@/components/wrapper"

const LeakChartView = ({ className = "" }) => {
  const { series, xLabels } = leakChartStore()

  return (
    <Wrapper.shadow className={className}>
      <ChartToolbar />
      <LeakChart series={series} xLabels={xLabels} />
    </Wrapper.shadow>
  )
}

export default LeakChartView
